import { useState, useRef } from "react";
import { Upload, X, Image as ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ImageUploader({ value, onChange, testid = "image-uploader", label = "Photo / Logo" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("Image trop volumineuse (max 5 Mo)"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const url = `${BACKEND_URL}${data.url}`;
      onChange(url);
      toast.success("Image téléchargée");
    } catch (e) {
      toast.error("Échec du téléversement");
    } finally { setUploading(false); }
  };

  return (
    <div>
      <label className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</label>
      <div className="mt-1 flex items-center gap-3">
        <div className="w-20 h-20 rounded-2xl border border-primary/15 overflow-hidden bg-secondary flex items-center justify-center flex-shrink-0">
          {value ? (
            <img src={value} alt="Aperçu" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon className="w-6 h-6 text-muted-foreground" />
          )}
        </div>
        <div className="flex-1 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="btn-outline text-xs"
            data-testid={`${testid}-btn`}
          >
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
            {value ? "Changer" : "Téléverser"}
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              className="text-xs text-red-600 hover:underline inline-flex items-center gap-1"
              data-testid={`${testid}-remove`}
            >
              <X className="w-3 h-3" /> Supprimer
            </button>
          )}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={(e) => handleFile(e.target.files?.[0])}
          className="hidden"
          data-testid={`${testid}-input`}
        />
      </div>
      <p className="text-[10px] text-muted-foreground mt-1">JPG, PNG, WEBP. Max 5 Mo.</p>
    </div>
  );
}
